import { MuiTheme } from "theme";
import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme: MuiTheme) => ({
  addEntryDialogPaper: {
    maxHeight: 355
  },
  addEntryDialogTitle: {
    display: "flex",
    padding: "0 8px 0 16px",
    borderBottom: "1px solid #d7d7d7",
    height: 48,
    "& > .MuiTypography-root": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flex: 1
    }
  },
  addEntryDialogCloseButton: {
    color: theme.palette.primary.dark
  },
  addEntryDialogCloseButtonIcon: {
    fontSize: 28
  },
  addEntryDialogContent: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
    padding: 16
  },
  addEntryDialogFormControl: {
    flex: "0 100%"
  },
  addEntryDialogInputLabel: {
    fontSize: 14,
    color: theme.palette.primary.dark,
    position: "relative",
    transform: "none",
    transformOrigin: "none",
    paddingBottom: 8,
    whiteSpace: "nowrap",
    "&.MuiFormLabel-root.Mui-focused": {
      color: theme.palette.primary.dark
    }
  },
  addEntryDialogInput: {
    padding: "0 16px",
    height: 36,
    fontSize: 12
  },
  addEntryDialogButtons: {
    display: "flex",
    justifyContent: "right",
    gap: 20
  },
  addEntryDialogButtonsAdd: {
    color: theme.palette.secondary.dark
  },
  searchResultsEntry: {
    padding: "8px 28px",
    background: theme.palette.common.white,
    borderBottom: "1px solid #d7d7d7",
    borderRadius: 0,
    height: 80,
    width: "100%",
    lineHeight: "20px",
    alignItems: "start",
    "&:hover": {
      background: theme.palette.common.white
    },
    "& .MuiButton-label": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      textTransform: "none"
    },
    "&:nth-child(odd)": {
      background: "#fafafa",
      "&:hover": {
        background: "#fafafa"
      }
    }
  }
}));
